'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _AimOutlined = _interopRequireDefault(require('./lib/icons/AimOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _AimOutlined;
exports.default = _default;
module.exports = _default;